import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { IApplication } from "../models/application";
import { searchApplication } from "../models/application";

/**
 * Service class to handle data and http request related to Application and Application-Template APIs.
 */
@Injectable({
  providedIn: "root",
})
export class ApplicationService {
  constructor(private http: HttpClient) { }

  sessionId: string = "";


  /* GET Requests (single) */

  /**
   * 1. Method to get the TEMPLATE of an application.
   * @param applicationIdentifier
   */
  getApplicationTemp(applicationIdentifier: any) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    // const url = `${environment.apiURL}/admin/application-template/get`;
    const url = `${environment.apiURL}/admin/application-template/v2/get`;
    return this.http.get<IApplication>(url, {
      params: { application_identifier: applicationIdentifier },
      headers: { 'cookie-header': `${this.sessionId}:${userName}` } 
    });
  }

  /*
  * Deprecated 
  */
  // getApplicationTempV3(applicationIdentifier: any) {
  //   const url = `${environment.apiURL}/admin/application-template/v3/get`;
  //   return this.http.get<IApplication>(url, {
  //     params: { application_identifier: applicationIdentifier },
  //   });
  // }

  async getApplicationTemplateV3(applicationIdentifier: any) {
    const parentUrl = document.referrer
      ? new URL(document.referrer).origin
      : null;
    console.log("ParentUrl", parentUrl);
    console.log("Document referrer: ", document.referrer);
    // const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin') || "";
    const jwtToken = sessionStorage.getItem('JWTToken') || "";
    // const userName = window.location.href.includes("nielit") ? sessionStorage.getItem('nielitUser') : JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/v3/get`;
    let templateData = await this.http.get<{ Application: IApplication }>(url, {
      params: { application_identifier: applicationIdentifier },
      ...((isGCCLogin || jwtToken) && {headers: { 
                  'gcc-login': isGCCLogin,
                  'x-api-key': jwtToken,
                  ...(parentUrl && {'X-Parent-Origin': parentUrl})
               } })
    }).toPromise();

    templateData.Application = await this.fetchDefinitionDataFromUrls(templateData?.Application);
    templateData.Application = await this.cleanDefinitionUrls(templateData?.Application);

    return templateData;
  }

  async fetchDefinitionDataFromUrls(app: IApplication): Promise<IApplication> {
    if (!app) {
      return app;
    }

    if (app.applicationDefinition_url) {
      app.applicationDefinition = await this.getData(app.applicationDefinition_url).toPromise();
    }
    if (app.configurationDefinition_url) {
      app.configurationDefinition = await this.getData(app.configurationDefinition_url).toPromise();
    }
    if (app.simulatorDefinition_url) {
      app.simulatorDefinition = await this.getData(app.simulatorDefinition_url).toPromise();
    }
    if (app.toolboxDefinition_url) {
      app.toolboxDefinition = await this.getData(app.toolboxDefinition_url).toPromise();
    }
    if (app.pythonInterfaceDefinition_url) {
      app.pythonInterfaceDefinition = await this.getData(app.pythonInterfaceDefinition_url).toPromise();
    }

    return app;
  }

  async cleanDefinitionUrls(app: IApplication): Promise<IApplication> {
    if (!app) {
      return app;
    }

    if (app.hasOwnProperty('configurationDefinition_url')) {
      delete app['configurationDefinition_url'];
    }
    if (app.hasOwnProperty('applicationDefinition_url')) {
      delete app['applicationDefinition_url'];
    }
    if (app.hasOwnProperty('toolboxDefinition_url')) {
      delete app['toolboxDefinition_url'];
    }
    if (app.hasOwnProperty('simulatorDefinition_url')) {
      delete app['simulatorDefinition_url'];
    }
    if (app.hasOwnProperty('pythonInterfaceDefinition_url')) {
      delete app['pythonInterfaceDefinition_url'];
    }

    return app;
  }

  getData(dataUrl: any) {
    const url = dataUrl;
    return this.http.get(url, { responseType: 'text' });
  }
  /**
   * Method to get particular APPLICATION.
   * @param applicationIdentifier
   */
  getApplication(applicationIdentifier: any) {
    // const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin') || "";
    // const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const jwtToken = sessionStorage.getItem('JWTToken') || "";
    const url = `${environment.apiURL}/admin/application/v2/get`;
    return this.http.get<IApplication>(url, {
      params: { application_identifier: applicationIdentifier },
      ...((isGCCLogin || jwtToken) && {headers: { 
                // 'cookie-header': `${this.sessionId}:${userName}`,
                 'gcc-login': isGCCLogin,
                 'x-api-key': jwtToken
                }})
    });
  }

  /* GET Requests (ALL) */

  /**
   * 1. Method to list all APPLICATION-TEMPLATE.
   * @param organizationID
   */
  getAllApplicationTemp(organization_id: string, module_name: string = "") {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/get-all?userName=${encodeURIComponent(userName)}`;
    return this.http.get<IApplication>(url, {
      params: {
        organization_id,
        module_name,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                 'gcc-login': `${isGCCLogin}`
               } 
    });
  }

  getAllApplicationTempRender(payload: any) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/get-all?userName=${encodeURIComponent(userName)}`;
 
    return this.http.get<any>(url, {
      params: {
        organization_id: payload.organizationId ?? '',
        applicationType: payload.applicationType ?? '',
        searchString: payload.searchString ?? '',
        moduleName: payload.moduleName ?? '',
        status: payload.status ?? '',
        createdDate: payload.createdDate ?? '',
        isLMSLogin: payload.isLMSLogin ?? '',
        page: payload.page ?? '',
        pageSize: payload.pageSize?? '',
        isMobile: payload.isMobile ?? ''
      },
      headers: {
        'cookie-header': `${this.sessionId}:${userName}`
      }
    });
  }

  getUserApplicationTemp(organization_id: string, module_name: string, user_name: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/get-template-application`;
    return this.http.get<IApplication>(url, {
      params: {
        organization_id,
        module_name,
        user_name
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}` }
    });
  }



  /**
   * 2. Method to list all APPLICATIONS.
   * @param organizationID
   * @param app_user_id
   */
  getAllApplication(organization_id: string, app_user_id: string, module_name: string, logged_in_user: string, status?: string, searchString?: string, createdAt?: string, isFromGCC?: boolean, isArduino?: boolean, isSimulatorApp?: boolean, page?: number, pageSize?: number) {
    
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application/get-all`;
    return this.http.post<IApplication>(url, {
      organizationId: organization_id,
      appUserId: app_user_id,
      moduleName: module_name,
      userName: logged_in_user,
      isGCCLogin: isFromGCC,
      status: status,
      searchString: searchString,
      createdDate: createdAt,
      isArduino: isArduino || false,
      isSimulatorApp: isSimulatorApp || false,
      page: page,
      pageSize: pageSize
    },
      {
        headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                   'gcc-login': `${isGCCLogin}`
                 } 
      });
  }

  // getAllSearchApplication(payload: any) {
  //   const user = sessionStorage.getItem('user');
  //   const userName = JSON.parse(user).username;
  //   this.sessionId = localStorage.getItem('sessionId');
  //   const url = `${environment.apiURL}/admin/application/get-all`;
  //   return this.http.post<any>(url, payload,
  //     {
  //       headers: { 'cookie-header': `${this.sessionId}:${userName}` }
  //     });
  // }

  /** POST Requests (create) */
  /**
   * 1. Method to create a new APPLICATION-TEMPLATE.
   * @param applicationTemp
   */
  createApplicationTemp(applicationTemp: IApplication) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/create`;
    return this.http.post<IApplication>(url, applicationTemp,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}` } });
  }

  /**
   * 2. Method to create a new APPLICATION-TEMPLATE.
   * @param application
   */
  createApplication(application: any) {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application/create`;
    return this.http.post<IApplication>(url, application,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                 'gcc-login': `${isGCCLogin}`
              } 
      });
  }

  /** PUT Requests (update) */

  /**
   * 1. Method to update an APPLICATION-TEMPLATE.
   * @param payload
   * @param applicationIdentifier
   */
  updateApplicationTemp(payload: any, applicationIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/update`;
    return this.http.put<IApplication>(url, payload, {
      params: {
        application_identifier: applicationIdentifier,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}` }
    });
  }

  updateApplicationTempV2(payload: any, applicationIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/v2/update`;
    return this.http.put<IApplication>(url, payload, {
      params: {
        application_identifier: applicationIdentifier,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                 'gcc-login': `${isGCCLogin}`
               } 
    });
  }

  updateApplicationTempV3(payload: any, applicationIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/v3/update`;
    return this.http.put<IApplication>(url, payload, {
      params: {
        application_identifier: applicationIdentifier,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}` }
    });
  }

  publishUnPublishApplication(payload: any, application_identifier: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    const url = `${environment.apiURL}/admin/application/publish-unpublish-application`;
    return this.http.put<any>(url, payload, {
      params: { application_identifier: application_identifier },
      headers: { 'cookie-header': `${sessionStorage.getItem('sessionId')}:${userName}` }
    });
  }

  updatepublish(payload: any, application_identifier: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/update-publish`;
    return this.http.put<any>(url, payload, {
      params: { application_identifier: application_identifier },
      headers: { 'cookie-header': `${this.sessionId}:${userName}` }
    });
  }

  getAllSearchApplicationTemp(payload: searchApplication) {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/get-all?userName=${encodeURIComponent(userName)}`;
    return this.http.get<any>(url, {
      params: {
        organization_id: payload.organizationId ?? '',
        applicationType: payload.applicationType ?? '',
        searchString: payload.searchString ?? '',
        moduleName: payload.moduleName ?? '',
        status: payload.status ?? '',
        createdDate: payload.createdDate ?? '',
      },
        headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                   'gcc-login': `${isGCCLogin}`
                 }
      });
  }

  getAllSearchApplication(payload: searchApplication) {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application/get-all`;
    return this.http.post<searchApplication>(url, payload,
      {
        headers: { 'cookie-header': `${this.sessionId}:${userName}`,
        'gcc-login': `${isGCCLogin}`
      }
      });
  }

  getTemplatePublish(application_identifier: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    const url = `${environment.apiURL}/admin/application-template/get-template-publish`;
    return this.http.get<any>(url, {
      params: { application_identifier: application_identifier },
      headers: { 'cookie-header': `${sessionStorage.getItem('sessionId')}:${userName}` }
    });
  }


  /**
   * 2. Method to update an APPLICATION.
   * @param payload
   * @param applicationIdentifier
   */
  updateApplication(payload: any, applicationIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application/update`;
    return this.http.put<IApplication>(url, payload, {
      params: {
        application_identifier: applicationIdentifier,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                 'gcc-login': `${isGCCLogin}`
               }
    });
  }

  updateApplicationV2(payload: any, applicationIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application/v2/update`;
    return this.http.put<IApplication>(url, payload, {
      params: {
        application_identifier: applicationIdentifier,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                 'gcc-login': `${isGCCLogin}`
               } 
    });
  }

  /** PUT Requests (update) v2 */

  /**
   * 1. Method to update an APPLICATION-TEMPLATE.
   * @param payload
   * @param applicationIdentifier
   */
  updateAppTemplateV2(payload: any, applicationIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/v2/update`;
    return this.http.put<IApplication>(url, payload, {
      params: {
        application_identifier: applicationIdentifier,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                 'gcc-login': `${isGCCLogin}`
               } 
    });
  }

  // /**
  //  * 2. Method to update an APPLICATION.
  //  * @param payload
  //  * @param applicationIdentifier
  //  */
  // updateApplication(payload: any, applicationIdentifier: string) {
  //   const url = `${environment.apiURL}/admin/application/update`;
  //   return this.http.put<IApplication>(url, payload, {
  //     params: {
  //       application_identifier: applicationIdentifier,
  //     },
  //   });
  // }

  /** DELETE Requests  */

  /**
   * Method to delete an APPLICATION-TEMPLATE.
   * @param applicationIdentifier
   */
  deleteApplicationTemp(applicationIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/delete`;
    return this.http.delete<IApplication>(url, {
      params: {
        application_identifier: applicationIdentifier,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}` }
    });
  }

  /**
   * 2. Method to delete an APPLICATION.
   * @param applicationIdentifier
   */
  deleteApplication(applicationIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application/delete`;
    return this.http.delete<IApplication>(url, {
      params: {
        application_identifier: applicationIdentifier,
      },
      headers: { 'cookie-header': `${this.sessionId}:${userName}` }
    });
  }

  /** Clone Requests  */

  /**
   * Method to Clone an APPLICATION-TEMPLATE.
   * @param applicationIdentifier
   */
  cloneApplicationTemplate(payload: any) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application-template/clone`;
    return this.http.post<IApplication>(url, payload,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}` }
    });
  }

  getApplicationIndustries() {
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application/get-industries`;
    return this.http.get<any>(url,
      {
        headers: { 'cookie-header': `${this.sessionId}:${userName}`,
                    'gcc-login': `${isGCCLogin}`
                }
      }).toPromise();
  }

  /**
   * 2. Method to Clone an APPLICATION.
   * @param applicationIdentifier
   */
  cloneApplication(payload: any) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/application/clone`;
    return this.http.post<IApplication>(url, payload,
      {
        headers: { 'cookie-header': `${this.sessionId}:${userName}` }
      });
  }

  getDummyDataFromLocalJSON() {
    return this.http.get<{}>('assets/json/circuitDefinition.json');
  }

  getDummyApplicationListFromLocalJSON() {
    return this.http.get<{}>('assets/json/application-list.json');
  }

  getDummyApplicationFromLocalJSON() {
    return this.http.get<{}>('assets/json/application-sensors.json');
  }

  gccAPI(challengeId: string, studentId: string, applicationIdentifier: string) {
    const url = `${environment.gccApiURL}studentChallenge/application`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer'+ ' ' + sessionStorage.getItem('gccToken')
      })
    }
    
    return this.http.post(url, {
        StudentId: studentId,
        ChallengeId: challengeId,
        ApplicationIdentifier: applicationIdentifier,
    }, httpOptions);
  }
}
